// Admin auth: PKCE/OAuth/JWT primitives come from @booking/core-ui; the token
// store is admin-specific (localStorage, "admin_*" keys). Re-exported here so the
// rest of admin keeps importing from "./auth" unchanged.
import { createTokenStore } from "@booking/core-ui/auth";

export {
  generatePKCE,
  generateState,
  getClientId,
  getClientType,
  getAuthorizeUrl,
  parseJwtPayload,
  isTokenExpired,
  type TokenData,
} from "@booking/core-ui/auth";

const store = createTokenStore({
  tokenStorage: "local",
  pkceStorage: "local",
  tokenKey: "admin_tokens",
  pkceKey: "admin_pkce",
});

export const {
  saveTokens,
  getTokens,
  clearTokens,
  getAccessToken,
  savePKCE,
  getPKCE,
  clearPKCE,
} = store;
